/**
 * 保养提醒线索
 */
import { MAINTAINREMIND } from '../types';

export default {
    name: `${MAINTAINREMIND}`,
    path: '/maintainRemind',
    component: () => import(/* webpackChunkName: 'maintainRemind' */ '@/views/maintainRemind/'),
    redirect: { name: `${MAINTAINREMIND}Index` },
    meta: {
        title: '保养提醒线索',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${MAINTAINREMIND}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'maintainRemind' */ '@/views/maintainRemind/home/Home.vue'),
        },

        // 详情
        {
            name: `${MAINTAINREMIND}Detail`,
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'maintainRemindDetail' */ '@/views/maintainRemind/detail/Detail.vue'),
        },
    ],
};
